<script setup>
import { useBetsStore } from '@/stores/bets';
import { onMounted, ref } from 'vue';

const props = defineProps({
    eid: [String, Number],
    sid: [String, Number]
})

const bets = useBetsStore()
const actions = ref([])
let lastResult = ref()

onMounted(async () => {
    await bets.fetchTimeline(props.eid).then(res => {
        if (res.status == 200) {
            actions.value = res.data.inc
            // lastResult.value = actions.value.find(a => a.type == 'score')?.results || '0-0'
        }
    })
})

const getIconPath = (type) => {
  try {
    return new URL(`/public/incidents/${type.toLowerCase()}.svg`, import.meta.url).href
  } catch {
    return null
  }
}
</script>

<template>
  <div class="bg-neutral-600/50 rounded-xl mt-2 px-2">
    <ul class="list-none py-2" v-if="actions.length > 0">
      <li
        v-for="action in actions"
        :key="action.id"
        class="relative flex items-center justify-between py-3 text-white text-xs"
        :class="(action.participant !== 0 && action.participant !== 1 && action.participant !== 2 && action.minute) ? 'flex-col gap-[50px]':''"
      >
        <span
          class="absolute left-1/2 transform -translate-x-1/2 w-[2px] bg-gray-600 top-0 bottom-0"
        ></span>

        <!-- participant == 1 -->
        <div
          v-if="action.participant == 1 || action.participant == 0"
          class="flex flex-col items-end text-right w-[45%] pr-2 z-10"
        >
          <div class="flex items-center justify-end gap-1">
            <p class="capitalize font-semibold leading-tight">
              {{ action.type.replaceAll('_', ' ') }}
            </p>
             <img
              v-if="getIconPath(action.type)"
              :src="getIconPath(action.type)"
              alt=""
              class="w-3 h-3"
            />
          </div>
          <p class="tml-ActionMessage">{{ action.source }}</p>
        </div>
        <div v-else class="w-[45%]"></div>

        <!-- Minute -->
        <div v-if="action.minute" class="minute-box z-10">
          <p>{{ action.minute }}'</p>
        </div>

        <!-- participant == 2 -->
        <div
          v-if="action.participant == 2"
          class="flex flex-col items-start text-left w-[45%] pl-2 z-10"
        >
          <div class="flex items-center gap-1">
            <img
              v-if="getIconPath(action.type)"
              :src="getIconPath(action.type)"
              alt=""
              class="w-3 h-3"
            />
            <p class="capitalize font-semibold leading-tight">
              {{ action.type.replaceAll('_', ' ') }}
            </p>
          </div>
          <p class="tml-ActionMessage">{{ action.source }}</p>
        </div>

        <!-- without participant -->
        <div
          v-else-if="(action.participant !== 0 && action.participant !== 1 && action.participant !== 2) "
          class="absolute left-1/2 transform -translate-x-1/2 text-center z-10 flex flex-col items-center"
        >
          <p class="font-semibold capitalize leading-tight flex items-center gap-1">
            <img
              v-if="getIconPath(action.type)"
              :src="getIconPath(action.type)"
              alt=""
              class="w-3 h-3"
            />
            {{ action.type.replaceAll('_', ' ') }}
          </p>
          <p class="tml-ActionMessage">{{ action.source }}</p>
        </div>

        <div v-else class="w-[45%]"></div>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.minute-box {
  @apply border border-gray-500 w-[34px] h-[32px] flex items-center justify-center rounded-sm text-xs text-white bg-neutral-700/50;
}

.tml-ActionMessage {
  font-size: 10px;
  line-height: 1.2;
  white-space: normal;
  overflow: visible;  
  text-overflow: unset;  
  max-width: 120px;
  word-break: break-word;
}
</style>
